import _eduNoticeBox from './eduNoticeBox.vue'

export default {
  install(Vue) {
    let eduNoticeBox = null;

    Vue.component(_eduNoticeBox.name, _eduNoticeBox);

    Vue.prototype.$eduNoticeBox = {
      show,
      hide,
      info,
      success,
      warning,
      danger
    };

    // 显示
    function show(props, callback) {
      // 如果已经存在，则不再创建
      if (!eduNoticeBox) {
        const EduNoticeBox = Vue.extend({
          render: h => h(_eduNoticeBox.name, {props}),
        });

        eduNoticeBox = new EduNoticeBox();
        this.vm = eduNoticeBox.$mount();
        document.body.appendChild(this.vm.$el);
      }
      callback && callback();
    }

    // 隐藏
    function hide(callback) {
      document.body.removeChild(this.vm.$el);
      eduNoticeBox.$destroy();
      eduNoticeBox = null;
      this.vm = null;
      callback && callback();
    }

    // 默认
    function info(props, callback) {
      this.show({...props, type: 'primary'}, callback);
    }

    // 成功
    function success(props, callback) {
      this.show({...props, type: 'success'}, callback);
    }

    // 警告
    function warning(props, callback) {
      this.show({...props, type: 'warning'}, callback);
    }

    // 错误
    function danger(props, callback) {
      this.show({...props, type: 'danger'}, callback);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/eduUI/eduNoticeBox/index.js